import {
    Avatar,
    Button,
    Card,
    Col,
    Popconfirm,
    Row,
    Switch,
    Typography,
    Progress,
    Empty,
    Tag,
    Statistic,
    List,
    Space,
    Collapse,
    Divider
} from "antd";
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    SettingOutlined,
    DeleteOutlined,
    GlobalOutlined,
    EyeOutlined,
    QuestionCircleOutlined,
    UserOutlined,
    ThunderboltOutlined, TrophyOutlined
} from '@ant-design/icons';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import Settings from "../settings"
import {Helmet} from 'react-helmet-async';
import ReactGA from "react-ga";
import {useTranslation} from "react-i18next";
import IG_image from "../assets/icons/ig.png";
import api from "./api";
import DynamicAdBanner from "./DynamicAddBanner";
import ChatPromoBanner from "./Fragments/ChatPromoBanner";

const { Title, Paragraph, Text } = Typography;
const { Panel } = Collapse;

function Home({analytics}) {
    const { t, i18n } = useTranslation();
    const [allQuizes, setAllQuizes] = useState([]);
    const [loadingQuizes, setLoadingQuizes] = useState(true);
    const [wallOfFame, setWallOfFame] = useState([]);
    const [userInfo, setUserInfo] = useState({ name: '', age: 0 });
    let {quizes, questions, settings, battle} = useSelector((data) => data)
    let passedCount = Object.values(quizes).length
    let navigate = useNavigate();
    const dispatch = useDispatch()
    const trueAnswers = (passedCount * 20) - questions.length;
    const answeredTotal = passedCount * 20;
    const accuracy = answeredTotal > 0 ? Math.round((trueAnswers / answeredTotal) * 100) : 0;
    
    const updateUserInfo = () => {
        const name = localStorage.getItem('chat_user_name');
        const age = localStorage.getItem('chat_user_age');
        if (name) setUserInfo({ name, age });
    };

    useEffect(() => {
        api.API.get(api.Quize).then((data) => {
            setAllQuizes(data);
            setLoadingQuizes(false);
        });

        api.API.get(api.RecentlyPassed).then((data) => {
            setWallOfFame(data || []);
        });

        updateUserInfo();
        window.addEventListener('user_info_updated', updateUserInfo);
        return () => window.removeEventListener('user_info_updated', updateUserInfo);
    }, []);

    const nextQuiz = allQuizes?.find(q => !quizes[q.id]);
    const recentPassed = allQuizes?.filter(q => quizes[q.id]).slice(-4).reverse();
    const progressPercent = Math.round((passedCount / 60) * 100); 
    
    useEffect(analytics, [])
    useEffect(() => {
        if (settings.app_version !== Settings.app_version) {
            if ('caches' in window) {
                caches.keys().then(keys => Promise.all(keys.map(key => {
                    return caches.delete(key);
                }))).then(() => {
                    dispatch({
                        payload: Settings.app_version, type: 'UPDATE_VERSION'
                    })
                })
            }
        }

    }, [])

    const onSwitchChange = (value) => {
        ReactGA.event({
            category: 'Config', action: 'fast_view', value: value ? 1 : 0
        });
        dispatch({
            payload: value, type: 'QUICK_VIEW'
        })
    }
    const handleLangChange = (value) => {
        const newLang = value ? 'hy' : 'ru';
        i18n.changeLanguage(newLang);
    }
    const handleClearWrongs = () => {
        dispatch({
            payload: Settings.app_version, type: 'CLEAR_WRONGS'
        })
    }
    const handleClearAnswers = () => {
        dispatch({
            type: 'CLEAR_ANSWERS'
        })
    }

    const faqData = i18n.language === 'hy' ? [
        {
            q: "Ինչպե՞ս պատրաստվել վարորդական քննությանը:",
            a: "Վարորդական տեսական քննությանը պատրաստվելու լավագույն միջոցը բոլոր 1200 հարցերի ուսումնասիրությունն է: Մեր կայքում դուք կարող եք անցնել թեստեր, կարդալ բացատրությունները և ամրապնդել գիտելիքները ըստ թեմաների:"
        },
        {
            q: "Քանի՞ հարց է լինելու իրական քննության ժամանակ:",
            a: "Իրական քննությունը բաղկացած է 20 հարցից: Քննությունը հանձնված է համարվում, եթե դուք թույլ եք տալիս առավելագույնը 2 սխալ:"
        },
        {
            q: "Արդյո՞ք հարցերը թարմացված են 2026 թվականի համար:",
            a: "Այո, մեր կայքի բոլոր հարցերը և ճանապարհային նշանները համապատասխանում են ՀՀ գործող օրենսդրությանը և վերջին փոփոխություններքին:"
        }
    ] : [
        {
            q: "Как подготовиться к экзамену на права в Армении?",
            a: "Лучший способ — изучить все 1200 вопросов. На нашем сайте вы можете проходить тесты, читать пояснения к вопросам и изучать темы отдельно."
        },
        {
            q: "Сколько вопросов на реальном экзамене?",
            a: "Экзамен состоит из 20 вопросов. Он считается сданным, если вы допустили не более 2 ошибок."
        },
        {
            q: "Актуальны ли вопросы для 2026 года?",
            a: "Да, все вопросы и дорожные знаки на сайте соответствуют текущему законодательству Армении и последним изменениям."
        }
    ];

    return (<Row gutter={[16, 16]}>
        <Helmet>
            <title>{t('seo.home_title')}</title>
            <meta name="description" content={t('seo.home_desc')}/>
            <meta property="og:title" content={t('seo.home_title')}/>
            <meta property="og:description" content={t('seo.home_desc')}/>
            <meta property="og:image" content="/logo.png"/>
            <link rel="canonical" href={window.location.origin} />
        </Helmet>

        <Col lg={24}>
            <div style={{textAlign: 'center', marginBottom: 20}}>
                <Title level={1} style={{fontSize: '2.5em', marginBottom: 10}}>AvtoDas.am</Title>
                <Title level={3} type="secondary" style={{marginTop: 0}}>{t('home.welcome_text')}</Title>

                {userInfo.name && (
                    <Card style={{
                        maxWidth: 600,
                        margin: '20px auto',
                        borderRadius: 15,
                        background: '#fafafa',
                        border: '1px solid #1890ff'
                    }}>
                        <Row align="middle" gutter={16}>
                            <Col xs={24} sm={12}>
                                <div style={{display: 'flex', alignItems: 'center', gap: 15}}>
                                    <Avatar size={64} style={{backgroundColor: '#1890ff'}} icon={<UserOutlined/>}/>
                                    <div style={{textAlign: 'left', flex: 1}}>
                                        <Title level={4} style={{margin: 0}}>{t('home.hello')}, {userInfo.name}!</Title>
                                        {userInfo.age > 0 && <Text type="secondary">{userInfo.age} {t('home.years_old')}</Text>}
                                    </div>
                                    <Button
                                        type="text"
                                        icon={<SettingOutlined/>}
                                        onClick={() => window.dispatchEvent(new Event('open_user_info_modal'))}
                                        title={t('home.change_info')}
                                    />
                                </div>
                            </Col>
                            <Col xs={24} sm={12}>
                                <div style={{ textAlign: 'right' }}>
                                    <Space size="middle">
                                        <Statistic 
                                            title={t('battle.wins', 'Հաղթանակներ')} 
                                            value={battle?.wins || 0} 
                                            prefix={<TrophyOutlined style={{ color: '#faad14' }} />} 
                                            valueStyle={{ fontSize: 20 }}
                                        />
                                        <Statistic 
                                            title={t('battle.points', 'Միավորներ')} 
                                            value={battle?.totalPoints || 0} 
                                            prefix={<ThunderboltOutlined style={{ color: '#1890ff' }} />}
                                            valueStyle={{ fontSize: 20 }}
                                        />
                                    </Space>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                )}
            </div>
        </Col>

        <Col lg={24}>
            <Card 
                style={{ 
                    borderRadius: 15, 
                    background: 'linear-gradient(135deg, #f5222d 0%, #722ed1 100%)',
                    border: 'none',
                    marginBottom: 10
                }}
                bodyStyle={{ padding: '20px 30px' }}
            >
                <Row align="middle" justify="space-between">
                    <Col xs={24} md={16}>
                        <Title level={3} style={{ color: '#fff', margin: 0 }}>
                            <ThunderboltOutlined /> {t('battle.mode_title', 'Quiz Battle Mode')}
                        </Title>
                        <Paragraph style={{ color: 'rgba(255,255,255,0.85)', margin: '10px 0 0', fontSize: 16 }}>
                            {t('battle.mode_desc', 'Մրցեք այլ օգտատերերի հետ իրական ժամանակում: Ով ավելի արագ և ճիշտ կպատասխանի նույն հարցերին:')}
                        </Paragraph>
                    </Col>
                    <Col xs={24} md={8} style={{ textAlign: 'right' }}>
                        <Button 
                            type="primary" 
                            size="large" 
                            onClick={() => navigate('/battle')}
                            style={{ 
                                background: '#fff', 
                                color: '#722ed1', 
                                border: 'none', 
                                fontWeight: 'bold',
                                height: 50,
                                borderRadius: 10,
                                padding: '0 40px',
                                marginTop: 15
                            }}
                        >
                            {t('battle.start_btn', 'ՍԿՍԵԼ ՄՐՑՈՒՅԹԸ')}
                        </Button>
                    </Col>
                </Row>
            </Card>
        </Col>

        <Col lg={24}>
            <ChatPromoBanner />
        </Col>

        {/* <DynamicAdBanner bannerId="6112605" />*/}
        <Col lg={24}>
            <Card>
                <Row gutter={[16, 16]} align="middle">
                    <Col xs={24} md={12}>

                        <Title level={4}>{t('home.progress')}</Title>
                        <Progress percent={progressPercent} status="active"
                                  strokeColor={{'0%': '#108ee9', '100%': '#87d068'}}/>
                        <Text type="secondary">{passedCount} / 60 {t('header.tests').toLowerCase()}</Text>
                    </Col>
                    {nextQuiz && (
                        <Col xs={24} md={12}>
                            <Card
                                size="small"
                                style={{background: '#f6ffed', border: '1px solid #b7eb8f'}}
                                title={<span>🚀 {t('home.next_quiz')}</span>}
                            >
                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                    <Title level={5} style={{margin: 0}}>{t('questions.tests')} №{nextQuiz.number}</Title>
                                    <Button type="primary" onClick={() => navigate(`/quizes/${nextQuiz.id}`)}>
                                        {t('home.answer')}
                                    </Button>
                                </div>
                            </Card>
                        </Col>
                    )}
                </Row>
            </Card>
        </Col>


        <Col lg={12} md={12} xs={24}>
            <Card title={<span><CheckCircleOutlined/> {t('home.results')}</span>} style={{height: '100%'}}>
                <Row gutter={[8, 8]}>
                    <Col span={12}>
                        <Statistic
                            title={t('home.true_answers')}
                            value={trueAnswers}
                            valueStyle={{color: '#3f8600', fontSize: '18px'}}
                            prefix={<CheckCircleOutlined/>}
                        />
                    </Col>
                    <Col span={12}>
                        <Statistic
                            title={t('home.wrong_answers')}
                            value={questions.length}
                            valueStyle={{color: '#cf1322', fontSize: '18px'}}
                            prefix={<CloseCircleOutlined/>}
                        />
                    </Col>
                    <Col span={24} style={{textAlign: 'center', marginTop: 10}}>
                        <Progress
                            type="circle"
                            percent={accuracy}
                            width={100}
                            strokeColor={{
                                '0%': '#ff4d4f',
                                '100%': '#52c41a',
                            }}
                        />
                        <div style={{marginTop: 15}}>
                            <Space wrap size={[4, 4]} justify="center">
                                <Tag color="blue" style={{margin: 0}}>{t('home.answered')}: {answeredTotal}</Tag>
                                <Tag color="orange"
                                     style={{margin: 0}}>{t('home.not_answered')}: {1200 - answeredTotal}</Tag>
                            </Space>
                        </div>
                        {questions.length > 0 && (
                            <Button
                                type="primary"
                                danger
                                block
                                icon={<CloseCircleOutlined/>}
                                onClick={() => navigate(`/wrongs`)}
                                style={{marginTop: 15}}
                            >
                                {t('home.answer')}
                            </Button>
                        )}
                    </Col>
                </Row>
            </Card>
        </Col>

        <Col lg={12} md={12} xs={24}>
            <Card title={<span><SettingOutlined/> {t('home.settings')}</span>} style={{height: '100%'}}>
                <List itemLayout="horizontal">
                    <List.Item
                        actions={[<Switch onChange={onSwitchChange} checked={settings.quick_view}/>]}
                    >
                        <List.Item.Meta
                            avatar={<EyeOutlined style={{fontSize: 20}}/>}
                            title={t('home.see_answer_end')}
                            description={t('home.see_answer_end_desc')}
                        />
                    </List.Item>
                    <List.Item
                        actions={[<Switch
                            checkedChildren="Հայ․"
                            unCheckedChildren="Рус."
                            checked={i18n.resolvedLanguage === 'hy'}
                            onChange={handleLangChange}
                        />]}
                    >
                        <List.Item.Meta
                            avatar={<GlobalOutlined style={{fontSize: 20}}/>}
                            title={t('home.site_lang')}
                            description={t('home.site_lang_desc')}
                        />
                    </List.Item>
                    <List.Item
                        actions={[
                            <Popconfirm
                                title={t('home.confirm_clear_wrongs')}
                                okText={t('home.yes')} cancelText={t('home.no')}
                                onConfirm={handleClearWrongs}
                            >
                                <Button type="text" danger icon={<DeleteOutlined/>}>{t('home.clear')}</Button>
                            </Popconfirm>
                        ]}
                    >
                        <List.Item.Meta
                            title={t('home.clear_wrongs_title')}
                            description={t('home.clear_wrongs_desc')}
                        />
                    </List.Item>
                    <List.Item
                        actions={[
                            <Popconfirm
                                title={t('home.confirm_clear_results')} okText={t('home.yes')}
                                cancelText={t('home.no')} onConfirm={handleClearAnswers}
                            >
                                <Button type="text" danger icon={<DeleteOutlined/>}>{t('home.clear')}</Button>
                            </Popconfirm>
                        ]}
                    >
                        <List.Item.Meta
                            title={t('home.clear_results_title')}
                            description={t('home.clear_results_desc')}
                        />
                    </List.Item>
                </List>
            </Card>
        </Col>

        <Col lg={24}>
            <Card style={{marginTop: 5, background: '#e6f7ff', border: '1px solid #91d5ff'}}>
                <Row align="middle" gutter={16}>
                    <Col xs={24} md={18}>
                        <Title level={4} style={{color: '#0050b3'}}>{t('home.learn_rules_title')}</Title>
                        <Paragraph>
                            {t('home.learn_rules_desc')}
                        </Paragraph>
                    </Col>
                    <Col xs={24} md={6} style={{textAlign: 'center'}}>
                        <Button type="primary" size="large" onClick={() => navigate(`/learn`)}
                                style={{borderRadius: '8px'}}>
                            {t('home.start_learning')}
                        </Button>
                    </Col>
                </Row>
            </Card>
        </Col>

        <Col lg={24}>
            <Card title={t('home.passed_quizzes')} style={{marginTop: 5}}>
                {recentPassed?.length > 0 ? (
                    <Row gutter={[16, 16]}>
                        {recentPassed.map(q => (
                            <Col xs={12} sm={8} md={6} key={q.id}>
                                <Card
                                    hoverable
                                    size="small"
                                    style={{textAlign: 'center'}}
                                    onClick={() => navigate(`/quizes/${q.id}`)}
                                >
                                    <Title level={5}>№{q.number}</Title>
                                    <Tag color={quizes[q.id] >= 18 ? 'green' : 'orange'}>
                                        {quizes[q.id]}/20
                                    </Tag>
                                </Card>
                            </Col>
                        ))}
                        <Col xs={24}>
                            <Button type="link" onClick={() => navigate(`/quizes`)}>
                                {t('questions.tests')} →
                            </Button>
                        </Col>
                    </Row>
                ) : (
                    <Empty description={t('home.no_passed_quizzes')}/>
                )}
            </Card>
        </Col>

        {/* Wall of Fame Section */}
        {wallOfFame.length > 0 && (
            <Col lg={24}>
                <Card 
                    title={<span style={{color: '#faad14'}}><UserOutlined/> {t('home.wall_of_fame')}</span>} 
                    style={{marginTop: 5, border: '1px solid #ffe58f', background: '#fffbe6'}}
                >
                    <List
                        grid={{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 5 }}
                        dataSource={wallOfFame}
                        renderItem={item => (
                            <List.Item>
                                <Card size="small" style={{borderRadius: 10, textAlign: 'center'}}>
                                    <Avatar style={{ backgroundColor: '#fde3cf', color: '#f56a00' }}>
                                        {item.name.charAt(0).toUpperCase()}
                                    </Avatar>
                                    <div style={{marginTop: 5}}>
                                        <Text strong>{item.name}</Text>
                                        <br/>
                                        <Tag color="green">
                                            {t('home.passed_with_score', {score: item.score || 20})}
                                        </Tag>
                                        <br/>
                                        <Text type="secondary" style={{fontSize: '0.8em'}}>
                                            {new Date(item.passed_at).toLocaleDateString()}
                                        </Text>
                                    </div>
                                </Card>
                            </List.Item>
                        )}
                    />
                </Card>
            </Col>
        )}

        {/* FAQ Section for SEO */}
        <Col lg={24}>
            <Card title={<span><QuestionCircleOutlined/> {t('home.faq_title')}</span>} style={{marginTop: 5}}>
                <Collapse ghost>
                    {faqData.map((item, index) => (
                        <Panel header={<Text strong>{item.q}</Text>} key={index}>
                            <Paragraph>{item.a}</Paragraph>
                        </Panel>
                    ))}
                </Collapse>
            </Card>
        </Col>

        <Col lg={24}>
            <Card>
                <div style={{textAlign: 'center'}}>
                    <Paragraph>
                        {t('home.description')}
                    </Paragraph>
                    <Divider/>
                    <Space size="large">
                        <Title level={5} style={{margin: 0}}>{t('home.contact_us')}</Title>
                        <a href={'https://www.instagram.com/avtodas.am/'} rel="noreferrer" target={'_blank'}>
                            <Avatar src={IG_image} size="large"/>
                        </a>
                    </Space>
                </div>
            </Card>
        </Col>
    </Row>)
}

export default Home;